import SearchResultMarker from '../../models/search/search_result_marker';

export default Backbone.GoogleMaps.LocationCollection.extend({
  // A collection of SearchResultMarkers.  This collection takes in a
  // SearchResults model and builds the collection .  The collection
  // updates itself whenever the SearchResults model changes.
  model: SearchResultMarker,
  markerWidth: 44,
  markerHeight: 56,
  scaleDownFactor: 2,

  constructor(optOptions) {
    this.searchResults = optOptions.searchResults;
    this.service_type = optOptions.service_type;
    delete optOptions.searchResults;
    delete optOptions.service_type;

    const models = [];

    // Create models for each of the 20 search result ranks
    for (let i = 1; i <= 20; i++) {
      models.push(
        new this.model({
          collection: this,
          rank: i,
          icon_off: this.getIconOff(i),
          icon_on: this.getIconOn(i),
        })
      );
    }

    // Get the models from the search results
    this.searchResults.on('change', _.bind(this.onSearchResultsChanged, this));

    Backbone.GoogleMaps.LocationCollection.prototype.constructor.call(this, models, optOptions);

    // Initialize the markers
    this.onSearchResultsChanged();
  },

  onSearchResultsChanged() {
    const results = this.searchResults.getResultsForType(this.service_type);
    const offset = this.searchResults.getOffsetForType(this.service_type);

    if (!results) {
      return;
    }

    this.each((marker, index) => {
      // Skip the first offset markers
      if (index < offset) {
        return;
      }

      // Don't go past the end of the results list
      if (index - offset >= results.length) {
        return;
      }

      const result = results[index - offset];
      marker.set({
        lat: result.latitude,
        lng: result.longitude,
        is_concealed: result.is_concealed,
      });
    });
  },

  commonIconData() {
    return {
      url: Rover.search.map.markersUrl,
      size: new google.maps.Size(
        this.markerWidth / this.scaleDownFactor,
        this.markerHeight / this.scaleDownFactor
      ),
      scaledSize: new google.maps.Size(
        this.markerWidth * 2 / this.scaleDownFactor,
        this.markerHeight * 20 / this.scaleDownFactor
      ),
    };
  },

  getIconOn(i) {
    const icon = this.commonIconData();
    icon.origin = new google.maps.Point(0, (i - 1) * this.markerHeight / this.scaleDownFactor);
    return icon;
  },

  getIconOff(i) {
    const icon = this.commonIconData();
    icon.origin = new google.maps.Point(
      this.markerWidth / this.scaleDownFactor,
      (i - 1) * this.markerHeight / this.scaleDownFactor
    );
    return icon;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/collections/search/search_result_marker_collection.js